import { Button, DialogTrigger, Flex, Text } from "@adobe/react-spectrum";
import styles from './sharesheet.module.scss';
import { SOCIAL_APP } from "@/constants/constants";

import Image from "next/image";
import Facebook from '@/assets/icons8-facebook-100.png';
import Twitter from '@/assets/icons8-twitterx-100.png';
import WhatsApp from '@/assets/icons8-whatsapp-100.png';
import CopyLink from '@/assets/icons8-link-100.png';
import { sendAdobeAnalyticsShareEvent } from '@/utils/utils';
import ShareIcon from '@spectrum-icons/workflow/Share';

import { HASHTAGS } from '@/constants/constants'

import { FacebookShareButton, TwitterShareButton, WhatsappShareButton } from 'react-share'
import { useEffect, useRef, useState } from "react";
import { useTranslations } from "next-intl";

export default function ShareSheet() {
    const [open, setOpen] = useState(false)
    const [url, setUrl] = useState("");
    const t = useTranslations("");
    const ref = useRef(null);

    useEffect(() => {
        setUrl(window.location.href);
    }, []);

    const sendAnalyticsEvent = (socialApp) => {
        sendAdobeAnalyticsShareEvent(socialApp);
    }

    const handleOpen = async () => {
        const userAgent = navigator.userAgent;
        if (/iPad|iPhone|iPod|android/i.test(userAgent)) {
            const shareData = {
                title: "Adobe Photoshop Express ",
                url: window.location.href,
                text: `#${HASHTAGS.join(" #")}`
            };
            try {
                await navigator.share(shareData)
            } catch (e) {
                // tslint:disable-next-line:no-empty
            }
        } else
            setOpen(true);

    }
    
    return <div>
        <div ref={ref}>
            <Button variant="primary" onPress={handleOpen} UNSAFE_className={styles.shareBtn}>
                <ShareIcon /> <Text>{t("share")}</Text>
            </Button>
        </div>
        <DialogTrigger type="popover" targetRef={ref} isOpen={open} onOpenChange={setOpen}>
            <Button variant="cta" UNSAFE_style={{ display: "none" }}>Share</Button>
            <Flex columnGap={10} alignItems={'center'} UNSAFE_className={styles.container}>
                <Flex direction={"column"} alignItems={"center"} rowGap={8}>
                <FacebookShareButton url={url} hashtag={`#${HASHTAGS[1]}`} title = "Adobe Photoshop Express" onClick={() => sendAnalyticsEvent(SOCIAL_APP.Facebook)}>
                        <Image className={`${styles.icon} ${styles.facebookIcon}`} width={50} height={50} alt="icon" src={Facebook} onClick={() => setOpen(!open)} />
                    </FacebookShareButton>
                    <Text>
                        Facebook
                    </Text>
                </Flex>

                <Flex direction={"column"} alignItems={"center"} rowGap={8}>
                    <WhatsappShareButton url={`${url}  #${HASHTAGS.join(" #")}`} title="Adobe Photoshop Express" onClick={() => sendAnalyticsEvent(SOCIAL_APP.Whatsapp)}>
                        <Image className={`${styles.icon} ${styles.whatsappIcon}`} width={50} height={50} alt="icon" src={WhatsApp} onClick={() => setOpen(!open)} />
                    </WhatsappShareButton>
                    <Text>
                        Whatsapp
                    </Text>
                </Flex>

                <Flex direction={"column"} alignItems={"center"} rowGap={8}>
                    <TwitterShareButton url={url} hashtags={HASHTAGS} title="Adobe Photoshop Express" onClick={() => sendAnalyticsEvent(SOCIAL_APP.Twitter)}>
                        <Image className={`${styles.icon} ${styles.twitterIcon}`} width={50} height={50} alt="icon" src={Twitter} onClick={() => setOpen(!open)} />
                    </TwitterShareButton>
                    <Text>
                        Twitter
                    </Text>
                </Flex>

                <Flex direction={"column"} alignItems={"center"} rowGap={8}>
                    <Image className={`${styles.icon} ${styles.copyLink}`} width={50} height={50} alt="icon" src={CopyLink} onClick={() => {
                        navigator.clipboard.writeText(`${url}`);
                        setOpen(!open);
                    }} />
                    <Text>
                        Copy link
                    </Text>
                </Flex>
            </Flex>
        </DialogTrigger>
    </div>
}